module.exports = __webpack_public_path__ + "img/tablet-relatorios.9b9a1eff.webp";